import React from "react";
import { Link } from "react-router-dom";
import { RiArrowLeftLine } from "react-icons/ri";
import PageLayout from "../components/PageLayout";

export default function NotFound() {
  return (
    <PageLayout 
        showSearch={false}
        pageTitle="Page Not Found"
    >
      <div className="flex flex-col items-center justify-center min-h-[calc(100vh-200px)] text-center">
        <div className="relative">
          <h1 className="font-medium text-[120px] leading-none text-secondary/10 max-md:text-[80px]">
            404
          </h1>
          <div className="absolute top-0 left-0 flex items-center justify-center w-full h-full">
            <div className="font-medium text-32 text-secondary max-md:text-24 whitespace-nowrap">
              Page Not Found
            </div>
          </div>
        </div>
        
        <div className="mt-4 text-16 text-light-gray/70 max-w-[500px]">
          The page you are looking for might have been removed, had its name changed, 
          or is temporarily unavailable.
        </div>
        
        <Link to="/" className="mt-8">
          <div className="inline-flex items-center px-6 py-3 font-medium transition-all duration-300 border rounded-full text-16 text-primary border-primary/20 hover:bg-primary/5 hover:shadow-lg hover:shadow-primary/5">
            <RiArrowLeftLine className="mr-2 size-5" />
            Back to Home
          </div>
        </Link>
        
        <div className="mt-12 text-14 text-light-gray/50">
          If you believe this is an error, please contact our support team.
        </div>
      </div>
    </PageLayout>
  );
} 